import { enableKeyIsValid } from "@aidkitorg/types/lib/eval";
import { ExpandedSurvey } from "@aidkitorg/types/lib/survey";
import { ChangeEventHandler, useMemo, useState } from "react";
import { findAndGoToComponent } from "../ConfigSearch";
import { QueryChecker } from "./QueryChecker";
import { expandTemplatesStrict, extractNotificationsAndPaymentsWithSearchTrees } from "@aidkitorg/types/lib/translation/v0_to_legacy";

const goToPaymentsTab = async (paymentName: string) => {
  const tab = document.getElementsByTagName('distro-editor')[0].shadowRoot!.querySelector("[data-tab-name=payments]");
  if (tab) tab.dispatchEvent(new Event('click', { bubbles: true }));
  await new Promise(r => setTimeout(r, 50));
  document.getElementsByTagName('distro-editor')[0].shadowRoot!
    .querySelector(`[data-name="${paymentName}"]`)?.scrollIntoView({ block: 'center' });
}
function PaymentDetail({ task, survey }: { task: NonNullable<ExpandedSurvey['payments']>[number] & { searchTree?: string[] }, survey: ExpandedSurvey['survey'] }) {
  return <QueryChecker
    component={task}
    name={task.name}
    onNameClick={() => task.searchTree ? findAndGoToComponent(task.searchTree!, survey) : goToPaymentsTab(task.name)}
    expr={task.condition}
    targetField={task.targetField}
    testName="Eligible"
  />
}

export default function PaymentsEditor({ survey } : { survey: ExpandedSurvey }) {

  const payments = useMemo(() => {
    // TODO: We expand templates a gajillion times
    const extractedNotifsAndPayments = extractNotificationsAndPaymentsWithSearchTrees(
      expandTemplatesStrict(survey.survey)
    );
    return [...(survey.payments || []), ...extractedNotifsAndPayments[1]]
  }, [survey]);

  if (!payments?.length) {
    return <div className="mt-4 ml-1">No payments yet!</div>
  }
  
  const [search, setSearch] = useState("");
  const filteredResults = useMemo(() => (payments ?? []).filter(
    item => item.name.toLowerCase().includes(search.toLowerCase())
      || item.targetField.toLowerCase().includes(search.toLowerCase())
  ), [search, payments])
  const enabled = useMemo(() =>
    filteredResults?.filter(p => enableKeyIsValid(p.enableKey, p)).length || 0
  , [filteredResults]);
  const onChangeSearch: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearch(e.target.value);
    const pane = document.getElementById("top-of-pane");
    if (pane) pane.scrollIntoView();
  }

  return <div>
    <div id="top-of-pane" />
    <input type="search" placeholder="Search for payments" value={search} onChange={onChangeSearch}
      className="block w-full border top-0 left-0 z-50 p-2 mt-1 mb-1 sticky sm:text-sm rounded-md" />

    <h4 className="text-center">{enabled}/{filteredResults?.length || 0} Enabled</h4>
    {filteredResults.map((t) => <PaymentDetail key={t.name} task={t} survey={survey.survey} />)}
  </div>
}
